import React, { useContext } from "react";
import { FormBuilderContext, ACTIONS } from "../context/context";

import InputSection from "../components/InputSection";
import ColorPickerInput from "../components/ColorPickerInput";
import CustomSelect from "../components/CustomSelect";
import FontFamilySelect from "../components/FontFamilySelect";
import { FormBuilderSwitch } from "../components/Switch";

const ErrorTextGroup = () => {
    const { state, dispatch } = useContext(FormBuilderContext);

    const handleToggleAddErrors = (event) => {
        dispatch({
            type: ACTIONS.TOGGLE_ERRORS,
            payload: event.target.checked,
        });
    };

    const handleColorChange = (actionType) => (color) => {
        dispatch({ type: actionType, payload: color });
    };

    const handleErrorTextFontWeightChange = (event) => {
        dispatch({
            type: ACTIONS.ERRORTEXT_FONT_WEIGHT_INPUT,
            payload: event.target.value,
        });
    };

    const handleErrorHeadFontWeightChange = (event) => {
        dispatch({
            type: ACTIONS.ERRORHEAD_FONT_WEIGHT_INPUT,
            payload: event.target.value,
        });
    };

    const handleErrorTextFontFontFamilyChange = (event) => {
        dispatch({
            type: ACTIONS.ERRORTEXT_FONT_FAMILY_CHANGE,
            payload: event.target.value,
        });
    };

    const handleErrorHeadFontFontFamilyChange = (event) => {
        dispatch({
            type: ACTIONS.ERRORHEAD_FONT_FAMILY_CHANGE,
            payload: event.target.value,
        });
    };



    return (


        <div>
            <p>Style the errors text?</p>
            <FormBuilderSwitch
                checked={state.addErrors}
                onChange={handleToggleAddErrors}
            />


            {state.addErrors && (

                <>
                    {/* #####################################  ERROR TEXT STYLES  ########################################### */}
                    <div className="input-group-wrapper">
                        <div>
                            <h2 className="section-subheader">Error Text styles</h2>
                            <div className="input-group-wrapper">

                                <div className="form-builder-section-div">
                                    <p>Font Family</p>
                                    <FontFamilySelect
                                        selectedFontFamily={state.errorTextFontFamily}
                                        onFontFamilyChange={handleErrorTextFontFontFamilyChange}
                                    />
                                </div>

                                <InputSection
                                    id="errorTextFontSize"
                                    title="Font size"
                                    value={state.errorTextFontSize}
                                    actionTypeIncrement={ACTIONS.ERRORTEXT_FONT_SIZE_INCREMENT}
                                    actionTypeDecrement={ACTIONS.ERRORTEXT_FONT_SIZE_DECREMENT}
                                    actionTypeInput={ACTIONS.ERRORTEXT_FONT_SIZE_INPUT}
                                    dispatch={dispatch}
                                />
                                <div>
                                    <p>Font Weight</p>
                                    <CustomSelect
                                        labelId="font-weight-error-text"
                                        id="font-weight-error-text"
                                        selectValue={state.errorTextFontWeight}
                                        selectLabel="Font Weight"
                                        selectOnChange={handleErrorTextFontWeightChange}
                                        menuItems={[
                                            { value: 100, label: "100" },
                                            { value: 200, label: "200" },
                                            { value: 300, label: "300" },
                                            { value: 400, label: "400" },
                                            { value: 500, label: "500" },
                                            { value: 600, label: "600" },
                                            { value: 700, label: "700" },
                                            { value: 800, label: "800" },
                                            { value: 900, label: "900" },
                                        ]}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="input-group-wrapper">

                        <InputSection
                            id="errorTextTopSpacing"
                            title="Top Spacing"
                            value={state.errorTextTopSpacing}
                            actionTypeIncrement={ACTIONS.ERRORTEXT_TOP_SPACING_INCREMENT}
                            actionTypeDecrement={ACTIONS.ERRORTEXT_TOP_SPACING_DECREMENT}
                            actionTypeInput={ACTIONS.ERRORTEXT_TOP_SPACING_INPUT}
                            dispatch={dispatch}
                        />

                        <InputSection
                            id="errorTextPaddingInline"
                            title="Padding"
                            value={state.errorTextPaddingInline}
                            actionTypeIncrement={ACTIONS.ERRORTEXT_INLINE_PADDING_INCREMENT}
                            actionTypeDecrement={ACTIONS.ERRORTEXT_INLINE_PADDING_DECREMENT}
                            actionTypeInput={ACTIONS.ERRORTEXT_INLINE_PADDING_INPUT}
                            dispatch={dispatch}
                        />
                        <div className="form-builder-section-div">
                            <p>Text Color</p>
                            <ColorPickerInput
                                color={state.errorTextColor}
                                onChange={handleColorChange(ACTIONS.ERRORTEXT_COLOR)}
                            />
                        </div>
                    </div>

                    {/* #####################################  ERROR HEADLINE STYLES  ########################################### */}
                    <div className="input-group-wrapper">
                        <div>
                            <h2 className="section-subheader">Error Headline styles</h2>
                            <div className="input-group-wrapper">

                                <div className="form-builder-section-div">
                                    <p>Font Family</p>
                                    <FontFamilySelect
                                        selectedFontFamily={state.errorHeadFontFamily}
                                        onFontFamilyChange={handleErrorHeadFontFontFamilyChange}
                                    />
                                </div>

                                <InputSection
                                    id="errorHeadFontSize"
                                    title="Font size"
                                    value={state.errorHeadFontSize}
                                    actionTypeIncrement={ACTIONS.ERRORHEAD_FONT_SIZE_INCREMENT}
                                    actionTypeDecrement={ACTIONS.ERRORHEAD_FONT_SIZE_DECREMENT}
                                    actionTypeInput={ACTIONS.ERRORHEAD_FONT_SIZE_INPUT}
                                    dispatch={dispatch}
                                />
                                <div>
                                    <p>Font Weight</p>
                                    <CustomSelect
                                        labelId="font-weight-error-head"
                                        id="font-weight-error-head"
                                        selectValue={state.errorHeadFontWeight}
                                        selectLabel="Font Weight"
                                        selectOnChange={handleErrorHeadFontWeightChange}
                                        menuItems={[
                                            { value: 100, label: "100" },
                                            { value: 200, label: "200" },
                                            { value: 300, label: "300" },
                                            { value: 400, label: "400" },
                                            { value: 500, label: "500" },
                                            { value: 600, label: "600" },
                                            { value: 700, label: "700" },
                                            { value: 800, label: "800" },
                                            { value: 900, label: "900" },
                                        ]}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="input-group-wrapper">

                        <InputSection
                            id="errorHeadBottomSpacing"
                            title="Bottom Spacing"
                            value={state.errorHeadBottomSpacing}
                            actionTypeIncrement={ACTIONS.ERRORHEAD_BOTTOM_SPACING_INCREMENT}
                            actionTypeDecrement={ACTIONS.ERRORHEAD_BOTTOM_SPACING_DECREMENT}
                            actionTypeInput={ACTIONS.ERRORHEAD_BOTTOM_SPACING_INPUT}
                            dispatch={dispatch}
                        />

                        <InputSection
                            id="errorHeadPaddingInline"
                            title="Padding"
                            value={state.errorHeadPaddingInline}
                            actionTypeIncrement={ACTIONS.ERRORHEAD_INLINE_PADDING_INCREMENT}
                            actionTypeDecrement={ACTIONS.ERRORHEAD_INLINE_PADDING_DECREMENT}
                            actionTypeInput={ACTIONS.ERRORHEAD_INLINE_PADDING_INPUT}
                            dispatch={dispatch}
                        />
                        
                    </div>
                    <div className="input-group-wrapper">
                    <div className="form-builder-section-div">
                            <p>Text Color</p>
                            <ColorPickerInput
                                color={state.errorHeadColor}
                                onChange={handleColorChange(ACTIONS.ERRORHEAD_COLOR)}
                            />
                        </div>
                        <div className="form-builder-section-div">
                            <p>Background Color</p>
                            <ColorPickerInput
                                color={state.errorHeadBackground}
                                onChange={handleColorChange(ACTIONS.ERRORHEAD_BACKGROUND_COLOR)}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
export default ErrorTextGroup;



























